import { App as AntdApp } from "antd";

import { useApp } from "./useApp";

import type { AppProps } from "antd/lib";

export function CustomApp(props: AppProps) {
  return <AntdApp {...props} />;
}

export const App = Object.assign(CustomApp, {
  ...AntdApp,
  useApp,
});
